import { render, staticRenderFns } from "./NumberRule.vue?vue&type=template&id=f59bf6f8"
import script from "./NumberRule.vue?vue&type=script&lang=js"
export * from "./NumberRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports